<template>
  <div class="register_main">
    <div class="register_main_sec left_col">
      <div class="signin-left-image">
        <img :src="signinImg" alt="">
      </div>
      <div class="bottom-image-wrapper">
        <div class="divider-container">
          <hr class="my-6 mr-3">
          <div>Use your account to access</div>
          <hr class="my-6 ml-3">
        </div>
        <div class="product-logo-wrapper">
          <router-link to="/">Home</router-link>
          <router-link to="/index">Workspace</router-link>
        </div>
      </div>
    </div>
    <div class="register_main_sec right_col">
      <div class="signup-right-title">Create new account</div>
      <div class="signup-right-form">
        <el-form
          :model="registerForm"
          :rules="registerRules"
          ref="registerForm"
          label-width="0px"
        >
          <el-form-item prop="username">
            <el-input
              v-model="registerForm.username"
              placeholder="请输入账号"
            >
              <template slot="prepend">
                <i class="el-icon-user"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="phoneNumber">
            <el-input
              v-model="registerForm.phoneNumber"
              placeholder="请输入手机号"
            >
              <template slot="prepend">
                <i class="el-icon-mobile-phone"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              style="float: left;"
              v-model="registerForm.imgCode"
              placeholder="请输入验证码"
              @keyup.enter.native="handleRegister"
            >
            </el-input>
            <img
              v-if="codeUrl"
              style="float: left; height: 56px; margin-left: 12px"
              :src="codeUrl"
              @click="getCode"
            />
          </el-form-item>
          <el-form-item prop="smsCode" style="position: relative;">
            <el-input
              v-model="registerForm.smsCode"
              placeholder="请输入短信验证码"
            >
              <template slot="prepend">
                <i class="el-icon-edit"></i>
              </template>
              <template slot="append">
                <span
                  v-if="!isSend"
                  style="cursor: pointer"
                  @click="handleSendMessage"
                  >发送验证码</span
                ><span v-if="isSend">{{ remain }} s</span>
              </template>
            </el-input>
            <span v-if="sendCode" style="margin-left: 8px;color:red;position:absolute;width:100px;text-align: left;right: -110px;line-height: 16px;">{{ sendCode }}</span>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="registerForm.password"
              placeholder="请输入登录密码"
            >
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input
              type="password"
              v-model="registerForm.confirmPassword"
              placeholder="请再次输入登录密码"
            >
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="inviter" v-if="rankCode !== '0000'">
            <el-input
              v-model="registerForm.inviter"
              placeholder="请输入邀请码"
            >
              <template slot="prepend">
                <i class="el-icon-edit-outline"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="false">
            <el-input
              v-model="registerForm.name"
              placeholder="请输入手机号"
            >
              <template slot="append">
                <el-button>发送短信</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="signup-button"
              type="primary"
              @click="handleRegister"
              >立即注册</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCodeImg, register, sendSms } from "@/api/login"
import signinImg from "@/assets/images/store-login-icon.svg"

export default {
  name: "register",
  data() {
    //确认密码校验
    let validateConfirmPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"))
      } else {
        callback()
      }
    }
    let validatePhone = (rule, value, callback) => {
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value === "") {
        callback(new Error("请输入手机号"))
      } else if (!reg_tel.test(value)) {
        callback(new Error("请输入正确的手机号"))
      } else {
        callback()
      }
    }
    return {
      codeUrl: "",
      registerForm: {
        username: "",
        password: "",
        phoneNumber: "",
        confirmPassword: "",
        imgCode: "",
        smsCode: "",
        channel: "",
        inviter: "",
      },
      registerRules: {
        username: [{ required: true, trigger: "blur", message: "请输入账号" }],
        phoneNumber: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        confirmPassword: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
        imgCode: [
          { required: true, trigger: "change", message: "请输入验证码" },
        ],
        smsCode: [
          { required: true, trigger: "blur", message: "请输入短信验证码" },
        ],
        inviter: [
          { required: true, trigger: "blur", message: "请输入邀请码" },
        ],
      },
      loading: false,
      isSend: false,
      remain: 60,
      sendCode: '',
      signinImg: signinImg,
    }
  },

  computed: {
    rankCode() {
      return this.$store.state.setting.siteData.rankCode
    },
  },
  created() {
    this.getCode()
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img
        this.registerForm.uuid = res.uuid
      })
    },
    handleRegister() {
      var _self = this
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let t = this.$route.query.t
          if (t) {
            this.registerForm.inviter = t
          }
          let channel = this.$route.query.channel
          if (channel) {
            this.registerForm.channel = channel
          }
          register(this.registerForm)
            .then((res) => {
              if (res.code == 200) {
                this.$alert(
                  '<strong style="color:#29ae89;font-size: 16px">恭喜你, 注册成功！请尽快完善个人信息！</strong>',
                  "",
                  {
                    dangerouslyUseHTMLString: true,
                  }
                ).then(() => {
                  _self.$router.push({ path: "/login" })
                })
              }
            })
            .catch(() => {
              this.loading = false
              this.getCode()
            })
        }
      })
    },
    async handleSendMessage() {
      try {
        if (this.isSend) {
          return
        }
        let _self = this

        let result = await sendSms({
          phoneNumber: this.registerForm.phoneNumber,
          imgCode: this.registerForm.imgCode,
          uuid: this.registerForm.uuid,
          type: "1",
        })
        if (result.code == 200) {
          let timer = window.setInterval(() => {
            _self.remain = Number(_self.remain) - 1
            if (this.remain == 0) {
              window.clearInterval(timer)
              _self.remain = 60
              this.isSend = false
            }
          }, 1000)
          this.isSend = true
          this.sendCode = result.msg
          // this.msgSuccess("短信发送成功")
        } else {
          this.getCode()
        }
      } catch (error) {
        this.$message.error(error.msg)
      }
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
  .register_main {
    width: 100%;
    display: flex;
    .register_main_sec {
      width: 50%;
      height: 100vh;
      .signin-left-image {
        display: flex;
        justify-content: center;
        margin-top: 12%;
        img {
          max-height: 680px;
          width: 80%;
        }
      }
      .bottom-image-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        width: 60%;
        .divider-container {
          align-items: center;
          color: #b5b5b5;
          display: flex;
          height: 19px;
          justify-content: space-evenly;
          margin: 29px 0;
          width: 100%;
          hr {
            border-style: solid;
            border-width: thin 0 0;
            color: inherit;
            display: block;
            flex: 1 1 100%;
            height: 0;
            max-height: 0;
            opacity: 0.12;
            transition: inherit;
          }
          div {
            font-size: 14px;
            min-width: 240px;
            text-align: center;
          }
          .ml-3 {
            margin-left: 12px;
          }
          .mr-3 {
            margin-right: 12px;
          }
          .my-6 {
            margin-bottom: 24px;
            margin-top: 24px;
          }
        }
        .product-logo-wrapper {
          display: flex;
          justify-content: space-between;
          width: 100%;
          a {
            color: #ffffff;
            font-weight: bold;
          }
        }
      }
    }
    .left_col {
      background: transparent linear-gradient(180deg, #171717, #393939) 0 0 no-repeat padding-box;
      background-size: cover;
      overflow: hidden;
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
    .right_col {
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .signup-right-title {
        // font-family: Roboto, Helvetica;
        font-size: 2em;
        height: 38px;
        margin-top: 6vh;
      }
      .signup-right-form {
        margin-top: 4vh;
        width: 60%;
        .signup-button {
          background-color: #4934b2;
          color: #fff;
          font: 16px Roboto;
          font-family: Roboto, Helvetica;
          height: 50px;
          width: 100%;
          border: none;
        }
        ::v-deep .el-input__inner {
          height: 56px;
        }
        ::v-deep .el-form-item__content {
          display: flex;
          align-items: center;
        }
        ::v-deep .el-input-group__prepend {
          font-size: 16px;
        }
      }
    }
  }
</style>
